import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { ArrowDownIcon, ArrowUpIcon, CheckmarkIcon } from '@treams/treams-icons';
import { Pill } from '@treams/treams-ui/common/Pill';

type CompetencyProgress = 'on-track' | 'above-level' | 'below-level';

type Props = {
	progress: CompetencyProgress;
};

const CompetencyProgressPill: FC<Props> = ({ progress }) => {
	const { t } = useTranslation();

	const getPillData = () => {
		if (progress === 'on-track') {
			return {
				title: t('growthPath.competency.onTrack'),
				color: 'green' as const,
				icon: <CheckmarkIcon />,
			};
		}

		if (progress === 'above-level') {
			return {
				title: t('growthPath.competency.aboveLevel'),
				color: 'green' as const,
				icon: <ArrowUpIcon />,
			};
		}

		if (progress === 'below-level') {
			return {
				title: t('growthPath.competency.belowLevel'),
				color: 'red' as const,
				icon: <ArrowDownIcon />,
			};
		}

		return undefined;
	};

	const pillData = getPillData();

	if (!pillData) {
		return null;
	}

	return (
		<Pill tint={pillData.color} small flexShrink={0}>
			<Flex alignItems="center">
				<Box size={16}>{pillData.icon}</Box>
				<Flex flexShrink={0}>{pillData.title}</Flex>
			</Flex>
		</Pill>
	);
};

export default CompetencyProgressPill;
